import React from "react";
import { exportTableToCsv } from "./csvExport";

function formatCell(v) {
  if (v === null || v === undefined) return "—";
  if (typeof v === "number") return Number.isInteger(v) ? v : v.toFixed(3);
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

/** Generic table renderer for an array of row-objects (auto-detects columns). */
function DataTable({ rows, title, exportName, excludeColumns }) {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  const excluded = new Set(excludeColumns || []);
  const columns = Array.from(rows.reduce((set, row) => {
    Object.keys(row || {}).forEach((k) => { if (!excluded.has(k)) set.add(k); });
    return set;
  }, new Set()));

  return (
    <div className="analysis-table-block">
      <div className="analysis-table-header">
        {title && <h4>{title}</h4>}
        <button className="analysis-export-btn" onClick={() => exportTableToCsv(rows, exportName || title || "table")}>
          Export CSV
        </button>
      </div>
      <div className="analysis-table-scroll">
        <table className="analysis-table">
          <thead>
            <tr>{columns.map((c) => <th key={c}>{c}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>{columns.map((c) => <td key={c}>{formatCell(row[c])}</td>)}</tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataTable;
